"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Banner = require("./Banner.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function createMarkup(html) {
  return {
    __html: html
  };
}
var Banner = exports.Banner = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var children = _ref.children,
    bannerStyle = _ref.bannerStyle,
    titleStyle = _ref.titleStyle,
    subTitleStyle = _ref.subTitleStyle,
    animation = _ref.animation,
    cameraPresenterId = _ref.cameraPresenterId;
  return /*#__PURE__*/_react["default"].createElement(_Banner.StyledBanner, (0, _extends2["default"])({
    id: "banner-".concat(cameraPresenterId),
    className: "dd-privacy-mask",
    dangerouslySetInnerHTML: createMarkup(children),
    bannerStyle: bannerStyle,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle
  }, animation));
});
Banner.defaultProps = {
  cameraPresenterId: '',
  bannerStyle: {},
  titleStyle: {},
  subTitleStyle: {},
  animation: {}
};
Banner.propTypes = {
  cameraPresenterId: _propTypes.string,
  children: _propTypes.string.isRequired,
  bannerStyle: _propTypes.object,
  titleStyle: _propTypes.object,
  subTitleStyle: _propTypes.object,
  animation: (0, _propTypes.shape)({
    initial: _propTypes.object,
    animate: _propTypes.object,
    exit: _propTypes.object,
    transition: _propTypes.object
  })
};